export enum RadioVariant {
  Radio = 'radio',
  Button = 'button',
  Chip = 'chip',
  Tile = 'tile',
}

export type RadioVariants = `${RadioVariant}`;
